import { createAction } from 'redux-actions';
import { timeMonth } from 'd3-time';
import { isoParse, timeFormat, timeParse } from 'd3-time-format';

import {
  descriptionCreator,
  idCreator,
  metaCreator,
  payloadCreator,
} from './creator';
import { checkForCachedDataAction, requestAction } from './request';
import fetch, {
  Api,
  defaultRequestConfig,
  getJson,
  handleError,
} from './fetch';

const ouraDayFormat = timeFormat('%Y-%m-%d');
const ouraDayParse = timeParse('%Y-%m-%d');
const ouraTimeParse = isoParse;

export const supportedTypes = ['sleep', 'activity', 'readiness'];

export const ouraFetchAction = createAction('GET_OURA_DATA', payloadCreator, metaCreator);

const getItemAdapter = type => (item) => {
  const parsed = {
    type,
    raw: item,
  };
  if (type === 'sleep') {
    parsed.time = ouraTimeParse(item.bedtime_start).toISOString();
    parsed.endTime = ouraTimeParse(item.bedtime_end).toISOString();
    parsed.duration = item.duration; // TODO: parse to minutes?
  } else if (type === 'activity') {
    parsed.time = ouraTimeParse(item.day_start).toISOString();
    parsed.endTime = ouraTimeParse(item.day_end).toISOString();
  } else if (type === 'readiness') {
    parsed.time = ouraDayParse(item.summary_date).toISOString();
  }
  return parsed;
};

const getUrl = ({ type, params }) => {
  const startTimeString = params.startTime
    ? `?start=${ouraDayFormat(params.startTime)}`
    : '';
  const endTimeString = params.endTime
    ? `${startTimeString.length ? '&' : '?'}end=${ouraDayFormat(params.endTime)}`
    : '';
  const url = `${Api}/oura/${
    type
  }${
    startTimeString
  }${
    endTimeString
  }`;
  return Promise.resolve(url);
};

const fetchData = ({ type, params }) => getUrl({ type, params })
  .then(url => fetch(url, defaultRequestConfig))
  .then(handleError)
  .then(getJson)
  .then(json => ({ [type]: json[type].map(getItemAdapter(type)) }));

const defaultParams = {
  startTime: timeMonth(new Date()),
};

export const getOuraData = ({ type, params = defaultParams }) => ((dispatch) => {
  if (!type) {
    return Promise.reject(new Error('No type specified'));
  }
  const id = idCreator();
  const description = descriptionCreator({ source: 'Oura', type, params });
  return checkForCachedDataAction(requestAction({ id, description }), dispatch)
    .then(() => fetchData({ type, params }))
    .then(data => dispatch(ouraFetchAction({ id, description, data })))
    .catch(error => dispatch(ouraFetchAction({ id, description, error: error.message || error })));
});

export default getOuraData;
